import { getDictionaries } from '@/basic-common/util/dictionaries'
import autocomplete_config from '@/basic-common/util/autocomplete-config.js' // 常用拼音码配置集
import validate from '@/util/validate.js'
import { getConfigInformation } from '@/api/common'
import { filtrConfig } from '@/basic-common/util/common.js'
import { getStore } from '@/util/store'

const moduleSelect = ['select', 'dic_select', 'multiple_tree', 'multiple_select', 'tree'] //普通接口组件
const moduleautocomplete = Object.keys(autocomplete_config) //拼音码接口组件

// 处理必填 和 placeholde
const setRequired = (itemConfig) => {
  // placeholde 处理三种类型
  if (!itemConfig.formPlaceholder)
    if (moduleautocomplete.includes(itemConfig.columnModel)) {
      itemConfig.placeholde = '拼音码检索'
    } else if (moduleSelect.includes(itemConfig.columnModel)) {
      itemConfig.placeholde = '请选择'
    } else {
      itemConfig.placeholde = '请输入'
    }

  itemConfig.rules = []

  // 数据验证分为必填验证和格式验证，两种类型可以并存
  if (itemConfig.isRequired === 1) {
    itemConfig.rules.push(
      {
        required: true,
        message: itemConfig.placeholde || itemConfig.formPlaceholder,
        trigger: ["blur", 'change']
      }
    )
  }
  if (itemConfig.columnType && Object.keys(validate).includes(itemConfig.columnType)) {
    itemConfig.rules.push(
      {
        validator: validate[itemConfig.columnType],
        trigger: ["blur", 'change']
      }
    )
  }
  return itemConfig
}
// 设置时间控件结束时间defaultTime
const setDatePickerDefaultTime = (itemConfig) => {
  itemConfig.defaultTime = '23:59:59'
  return itemConfig
}

// JSON转对象
const TO_JSON = (JSON_STR) => {
  try {
    return JSON.parse(JSON_STR)
  } catch (err) {
    console.log(err);
    throw new Error('不能识别的JSON格式')
  }
}
// 对象转查询参数字符串
const objToQueryString = (obj) => {
  let querystr = '';
  for (const key in obj) {
    querystr += key + "=" + obj[key] + "&";
  }
  return querystr.substring(0, querystr.length - 1);
}

// 1. 组件清洗共有参数
export function disposeDic(configItem) {
  const isJsonConfig = configItem.dictKey ? configItem.dictKey.indexOf('{') > -1 : null;  //是否存在并且为配置JSON
  configItem = setRequired(configItem)
  // 设置结束时间的defaultTime
  if ([
    'searchEndTime',
    'endTime'
  ].includes(configItem.columnAlias)) {
    configItem = setDatePickerDefaultTime(configItem)
  }
  try {
    if (![...moduleSelect, ...moduleautocomplete].includes(configItem.columnModel)) {
      return configItem
    }

    // dictKey配置两种方式： 1、业务字典key 2、JSON配置(如单位)
    const JSONData = isJsonConfig ? TO_JSON(configItem.dictKey) : { label: 'dictValue', value: 'dictKey', url: '' }
    configItem.props = {
      label: JSONData.label,
      value: JSONData.value
    }
    configItem.requestUrl = JSONData.url

    // 业务字典类型（枚举值取缓存）
    if (['dic_select', 'multiple_select'].includes(configItem.columnModel)) {
      const commonDict = getStore({ name: 'commonDict' }) || {} // 业务字典值
      configItem.dicData = commonDict[configItem.dictKey] || []
      configItem.requestUrl = `/api/blade-system/dict-biz/dictionary?code=${configItem.dictKey}`
    }

    // 拼音码相关
    if (moduleautocomplete.includes(configItem.columnModel)) {
      const { customQuery, url, value, label } = autocomplete_config[configItem.columnModel]
      const query = objToQueryString(customQuery)

      if (configItem.queryShowFlag) {
        configItem.dicUrl = `${url}?searchCode={{key}}&${query}`
      }
      configItem.remote = true;
      configItem.props = {
        label: label,
        value: value
      }
    }

    return configItem
  } catch (err) {
    console.log(err);
    return configItem
  }
}


//公共获取配置参数方法 Config
export function getTableConfig(config = {}, callBack) {

  this[config.loading || 'basicLoading'] = true
  const { path } = this.$route
  let that = this
  this.initstate = true
  getConfigInformation({ functionAlias: config.url || path, deptId: config.deptId || getStore({ name: 'userInfo' }).dept_id || '' }).then((res) => {
    if (!res.data.data) {
      return this.$message.error(`“${path}”功能，获取配置参数异常，请联系管理员`)
    }
    // 主表数据
    const {
      mainTableConfig: { tableConfigSubList: mainTableConfig },
    } = res.data.data

    this.mainTableConfigList = mainTableConfig
    filtrConfig.call(this, mainTableConfig, data => {
      this.option.column = data
      this.option.searchShow = res.data.data.mainTableConfig.isFold === 1 ? false : true
      const searchDate = this.findObject(this.option.column, 'searchDate')
      if (searchDate && searchDate != -1) {
        searchDate && this.$set(searchDate, 'defaultTime', ['00:00:00', '23:59:59'])
      }
      //解析默认值函数
      this.queryMenuExceMethod && this.queryMenuExceMethod()
      that.$refs.crud && that.$refs.crud.init()
      this.getTableHeightEvent && this.getTableHeightEvent()
      !this.option.closeSearchAuto && this.queryAutoArrange && this.queryAutoArrange(this.option.searchSpanNumber);
      this.onLoad && this.onLoad(this.page, this.query)
      this[config.loading || 'basicLoading'] = false
      // 加载tree,select类型相关网络请求
      loadDic.call(this, config.option)
      callBack && callBack()
    })
    // 子表数据
    if (res.data.data && res.data.data.subTableConfig) {
      const {
        subTableConfig: { tableConfigSubList: subTableConfigList },
      } = res.data.data

      this.subTableConfigList = subTableConfigList
    }

  })
}

// 加载级联接口请求
export async function loadDic(option) {
  // 数组处理子表数据
  let column = option instanceof Array ? option : option.column
  const sendDic = async (ele) => {
    const newColumn = this.findObject(column, ele.prop);
    newColumn.dicData = await getDictionaries(ele.requestUrl)
  };
  column.forEach(ele => {
    const isJsonConfig = ele && ele.dictKey ? ele.dictKey.indexOf('{') > -1 : false;  //是否存在并且为配置JSON
    if (isJsonConfig) sendDic(ele)
  });
}

// 单独设置 placeholder
export async function setFieldPlaceholder(column, prop, placeholder = '请选择') {
  const columnObj = this.findObject(column, prop);
  if (columnObj !== -1) {
    columnObj.placeholder = placeholder
    columnObj.rules.forEach(item => {
      if (item.required) return item.message = placeholder
    })
  }
}

// 设置 searchPlaceholder
export async function setSearchPlaceholder(column, prop, placeholder = '请选择') {
  const columnObj = this.findObject(column, prop);
  if (columnObj !== -1) {
    columnObj.searchPlaceholder = placeholder
  }
}
